__turbopack_context__.v({
  "errorPage": "ErrorPage-module-scss-module__AZco5W__errorPage",
  "illustration": "ErrorPage-module-scss-module__AZco5W__illustration",
  "pageText": "ErrorPage-module-scss-module__AZco5W__pageText",
  "pageTitle": "ErrorPage-module-scss-module__AZco5W__pageTitle",
  "toHomeButton": "ErrorPage-module-scss-module__AZco5W__toHomeButton",
  "wiggle": "ErrorPage-module-scss-module__AZco5W__wiggle",
});
